import { Component, ViewEncapsulation } from "@angular/core";

@Component({
    templateUrl: "./not-found.html",
    encapsulation: ViewEncapsulation.None
})
export class NotFoundPage {
}